<script>
import DefaultLoginPage from './customLoginPage/defaultLoginPage'
import empregosagrologin from './customLoginPage/empregosagrologin'
import empregatransportelogin from './customLoginPage/empregatransportelogin'
import acatslogin from './customLoginPage/acatsLoginPage'
import Vivaelogin from './customLoginPage/vivaelogin'
import fenaconlogin from './customLoginPage/portalfenaconlogin'
import Wfgloballogin from './customLoginPage/wfgloballogin'
import courseralogin from './customLoginPage/courseralogin'
import acatelogin from './customLoginPage/acatelogin'
import govsplogin from './customLoginPage/govsplogin'
import govmtlogin from './customLoginPage/govmtlogin'
import govmglogin from './customLoginPage/govmglogin'
import goveslogin from './customLoginPage/goveslogin'
import senacsclogin from './customLoginPage/senacsclogin'
import decolaentregadoreslogin from './customLoginPage/decolaentregadoreslogin'
import { mapActions } from 'vuex'
import CorporateLoginPage from './customLoginPage/corporateLoginPage'
import AuthTemplate from '@/components/authentication/AuthTemplate'
import { redirectToSsoLogin } from '@/support/sso'

export default {
  name: 'LoginPage',
  components: {
    DefaultLoginPage,
    empregosagrologin,
    empregatransportelogin,
    Vivaelogin,
    fenaconlogin,
    acatslogin,
    Wfgloballogin,
    courseralogin,
    acatelogin,
    govmtlogin,
    govmglogin,
    govsplogin,
    goveslogin,
    senacsclogin,
    decolaentregadoreslogin,
    CorporateLoginPage,
    AuthTemplate
  },
  data () {
    return {
      attemptingLogin: false,
      pwOrEmailInvalid: false,
      showCorporateDecision: false,
      authenticatedUser: null
    }
  },
  methods: {
    ...mapActions(['setLanguage', 'setAuthIntent']),
    handleIntentWithStoredUser () {
      const storedUser = this.$store.getters.getUser
      if (!storedUser) return
      const companies = storedUser.companies || []

      if (this.loginType === 'candidate') {
        if (companies.length > 0 && !this.$route.query.theme) {
          this.showCorporateDecision = true
          this.authenticatedUser = storedUser
          return
        }
        this.$router.push({ name: 'workspace.selection.index' })
        return
      }

      if (this.loginType === 'corporate') {
        if (!companies.length) {
          this.handleCorporateWithoutCompany()
          return
        }
        this.handleCorporateRedirection(storedUser)
      }
    },
    changeLanguage (language) {
      this.setLanguage(language)
    },
    async submit (formData) {
      try {
        this.attemptingLogin = true
        const response = await this.$store.dispatch('attemptPerformLogin', { email: formData.email, password: formData.password, workspace: this.$route.query.theme })
        const loginIntent = this.loginType
        this.setAuthIntent(loginIntent)
        this.setPlooralGlobalToken(response.data.token)
        const userData = response.data.user
        let isSupport = false
        isSupport = !!(userData && userData.isSupport)
        if (response.data && !isSupport) {
          try {
            this.$store.getters.getUserWorkspaces.map(workspace => {
              if (this.$route.name.includes(workspace.type)) {
                if (workspace.type === 'individual' || (this.$route.params.companyDomain && this.$route.params.companyDomain.toLowerCase() === workspace.subdomain.replace(/\s+/g, '').toLowerCase())) {
                  this.$store.commit('setSelectedWorkspace', workspace)
                }
              }
            })

            if (userData.language) {
              this.changeLanguage(userData.language)
            }
            this.attemptingLogin = false

            if (this.$route.query.theme) this.$store.commit('updateSetThemeWorkspace', this.$route.query.theme)

            const uri = decodeURIComponent(this.$route.query.redirect)

            if (loginIntent === 'corporate') {
              if (!userData.companies || !userData.companies.length) {
                this.handleCorporateWithoutCompany()
                return
              }
              this.handleCorporateRedirection(userData)
              return
            }

            if (uri !== 'undefined') {
              location.href = uri
            } else {
              if (loginIntent === 'candidate' && (!userData.companies || userData.companies.length === 0)) {
                this.$router.push({ name: 'individual.home.user' })
              } else if (loginIntent === 'candidate' && userData.companies && userData.companies.length > 0) {
                if (this.$route.query.theme) {
                  this.$router.push({ name: 'workspace.selection.index' })
                } else {
                  this.showCorporateDecision = true
                  this.authenticatedUser = userData
                }
              } else {
                this.$router.push({ name: 'workspace.selection.index' })
              }
            }
          } catch (error) {
            this.attemptingLogin = false
          }
        } else if (isSupport) {
          this.debounceEvent(() => {
            this.$store.dispatch('attemptSetFeedbackMsg', {
              type: 'error',
              title: this.$t('support.user.not.allowed')
            })
          }, 1000)
        }
        this.$store.commit('setLanguageIsLoaded', true)
      } catch (error) {
        if (error.response && error.response.status === 403 && error.response.data && error.response.data.msg === 'sso_required') {
          const subdomain = error.response.data.subdomain
          if (this.loginType === 'corporate') {
            redirectToSsoLogin()
          } else if (subdomain) {
            this.$router.push({ path: '/clogin', query: { sso: subdomain } })
          } else {
            this.$router.push({ name: 'auth.login.corporate' })
          }
          return
        }
        this.pwOrEmailInvalid = true
        this.attemptingLogin = false
      }
    },
    handleCorporateWithoutCompany () {
      this.$store.dispatch('attemptSetFeedbackMsg', {
        type: 'error',
        title: this.$t('login.corporate:no.company')
      })

      this.attemptingLogin = false
      this.pwOrEmailInvalid = false

      this.$store.commit('updateUserToken', null)
      this.$store.commit('updateUser', { clear: true })
      localStorage.clear()
    },
    handleCorporateRedirection (userData) {
      const redirect = this.$route.query.redirect
      if (redirect && redirect !== 'undefined') {
        window.location.href = decodeURIComponent(redirect)
        return
      }

      const companies = userData.companies || []
      if (companies.length === 1) {
        window.location.href = `/c/${companies[0].subdomain}/hire/dashboard/home`
      } else {
        this.$router.push({ name: 'workspace.selection.index' })
      }
    },
    goToCandidateSpace () {
      const redirect = this.$route.query.redirect
      if (redirect && redirect !== 'undefined') {
        window.location.href = decodeURIComponent(redirect)
        return
      }
      this.$router.push({ name: 'individual.home.user' })
    },
    goToCorporateSpace () {
      if (!this.authenticatedUser || !this.authenticatedUser.companies) return

      const companies = this.authenticatedUser.companies
      this.setAuthIntent('corporate')

      if (companies.length === 1) {
        window.location.href = `/c/${companies[0].subdomain}/hire/dashboard/home`
      } else {
        this.$router.push({ name: 'workspace.selection.index' })
      }
    }
  },
  computed: {
    theme () {
      return this.$route.query.theme
    },
    loginType () {
      return this.$route.meta && this.$route.meta.loginType ? this.$route.meta.loginType : 'candidate'
    }
  },
  created () {
    this.setAuthIntent(this.loginType)
    this.handleIntentWithStoredUser()
    // eslint-disable-next-line no-undef
    zE('webWidget', 'hide')
  },
  beforeRouteLeave (to, from, next) {
    // eslint-disable-next-line no-undef
    zE('webWidget', 'show')
    next()
  }
}
</script>
<template>
  <div class="login-page--container">
    <vivaelogin v-if="theme === 'vivae'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></vivaelogin>
    <fenaconlogin v-if="theme === 'portalfenacon'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></fenaconlogin>
    <wfgloballogin  v-else-if="theme === 'pwfglobal'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit">
    </wfgloballogin>
    <empregosagrologin v-else-if="theme === 'empregosagro'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></empregosagrologin>
    <empregatransportelogin v-else-if="theme === 'empregatransporte'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></empregatransportelogin>
    <acatslogin v-else-if="theme === 'acats'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></acatslogin>
    <courseralogin v-else-if="theme === 'coursera'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></courseralogin>
    <acatelogin v-if="theme === 'acate'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></acatelogin>
    <govsplogin v-else-if="theme === 'govsp'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></govsplogin>
    <govmglogin v-else-if="theme === 'govmg'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></govmglogin>
    <govmtlogin v-else-if="theme === 'govmt'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></govmtlogin>
    <goveslogin v-else-if="theme === 'goves'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></goveslogin>
    <senacsclogin v-else-if="theme === 'senacsc'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></senacsclogin>
    <decolaentregadoreslogin v-else-if="theme === 'decolaentregadores'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid" @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    ></decolaentregadoreslogin>
    <corporate-login-page v-if="loginType === 'corporate'" :isAttemptingLogin="attemptingLogin"
      :pwOrEmailInvalid="pwOrEmailInvalid"
      switchTarget="/login"
      :switch-label="$t('login.corporate:switch.candidate')"
      @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"
    />
    <auth-template v-else-if="showCorporateDecision" color="defaultLogin" :title="$t('global:welcome')" :subtitle="$t('login.page:subtitle')" :language="$store.getters.getLanguage">
      <template v-slot:image>
        <img src="/assets/images/customers/plooral-hand.png" height="100%" />
      </template>
      <template v-slot:form>
        <div class="login--container">
          <v-card class="login-form--wrapper">
            <div class="corporate-decision">
              <h4 class="decision-title">
                {{ $t('login.candidate.decision:title') }}
              </h4>
              <p class="decision-subtitle">{{ $t('login.candidate.decision:description') }}</p>

              <div class="decision-actions">
                <v-btn
                  style="color: white; font-size: 16px;"
                  class="mt-10 btn bold transform-unset decision-btn-primary"
                  color="#1200D3"
                  large
                  block
                  @click="goToCorporateSpace"
                >
                  {{ $t('login.candidate.decision:go.corporate.title') }}
                </v-btn>

                <v-btn
                  style="color: #1200D3; font-size: 16px; border: 2px solid #1200D3;"
                  class="mt-5 btn bold transform-unset decision-btn-secondary"
                  color="transparent"
                  large
                  block
                  @click="goToCandidateSpace"
                >
                  {{ $t('login.candidate.decision:stay.candidate') }}
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </template>
    </auth-template>
    <!-- Login Normal -->
    <default-login-page v-else :isAttemptingLogin="attemptingLogin" :pwOrEmailInvalid="pwOrEmailInvalid"
      switchTarget="/clogin"
      :switchLabel="$t('login.form:switch.corporate')"
      @disableErrorPw="pwOrEmailInvalid = false" @submit="submit"></default-login-page>
  </div>
</template>
<style lang="scss">
.login--container {
  max-width: 100%;
  width: 515px;

  .login-form--wrapper {
    padding: 45px 64px;
    border-radius: 10px;
    text-align: left;

    .registration-form-subtitle {
      @extend .subtitle--1;
      @extend .neutral-medium;
    }
  }

  @media only screen and (max-width: 768px) {
    .login-form--wrapper {
      border-radius: 10px 10px 0 0;
      padding: 36px 24px 80px;
    }
  }
}

.corporate-decision {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .decision-title {
    font-size: 24px;
    font-weight: 700;
    color: #242321;
    margin-bottom: 16px;
    line-height: 1.3;

    span {
      display: block;
    }
  }

  .decision-subtitle {
    font-size: 16px;
    color: #666;
    margin-bottom: 32px;
    line-height: 1.4;
  }

  .decision-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .decision-btn-secondary {
      border: 2px solid #1200D3 !important;
      background-color: transparent !important;

      &:hover {
        background-color: rgba(18, 0, 211, 0.05) !important;
      }
    }
  }

  @media (max-width: 768px) {
    min-height: 350px;

    .decision-title {
      font-size: 20px;
    }
  }
}
</style>
